/**
 * @name UserStatus
 * @description 사용자 계정 상태
 */
export const UserStatus = {
  ACTIVE: '정상',
  WITHDRAWN: '탈퇴',
  BLOCKED: '차단',
} as const;
